<template>
  <div v-if="formData">
    <table class="table table-bordered table-striped">
      <tr>
        <td colspan="3">
          <div class="row">
            <div class="col-6">
              <img
                v-if="formData.OrganisationLogo"
                :src="formData.OrganisationLogo"
                style="width: 40%"
              />
            </div>
            <div class="col-6 text-right">
              <img src="/assets/careerlibrary.jpg" style="width: 40%" />
            </div>
          </div>
          <label style="font-size: 1.3rem; font-weight: 600"
            >Leave Application</label
          ><br />
          <label class="title">Employee</label>:
          <label class="content">{{ formData.EmployeeName }}</label
          ><br />
          <label class="title">Created Date</label>:
          <label class="content">{{ formData.CreatedDateStr }}</label>
        </td>
      </tr>
      <tbody>
        <tr>
          <td><b>Leave Type</b></td>
          <td><b>Start Date</b></td>
          <td><b>End Date</b></td>
        </tr>
        <tr>
          <td width="33.33%">{{ formData.LeaveTypeDescription }}</td>
          <td width="33.33%">{{ formData.StartDateDisplay }}</td>
          <td width="33.33%">{{ formData.EndDateDisplay }}</td>
        </tr>
        <tr>
          <td colspan="3"><b>Number of Leave Days</b></td>
        </tr>
        <tr>
          <td colspan="3">{{ formData.NumberOfLeaveDays }}</td>
        </tr>
        <tr>
          <td colspan="3"><b>Remarks</b></td>
        </tr>
        <tr>
          <td colspan="3">{{ formData.Remarks }}</td>
        </tr>
        <tr>
          <td colspan="3"><b>Approver Name</b></td>
        </tr>
        <tr>
          <td colspan="3">{{ formData.ApproverName }}</td>
        </tr>
        <tr>
          <td colspan="3"><b>Approver Email</b></td>
        </tr>
        <tr>
          <td colspan="3">{{ formData.ApproverEmail }}</td>
        </tr>
        <tr>
          <td colspan="3"><b>Status</b></td>
        </tr>
        <tr>
          <td colspan="3">{{ formData.Status }}</td>
        </tr>
        <tr v-if="formData.LeaveTypeDescription == 'Medical Leave'">
          <td colspan="3"><b>Medical Certificate</b></td>
        </tr>
        <tr v-if="formData.LeaveTypeDescription == 'Medical Leave'">
          <td colspan="3">
            <download-mc-button
              :mcFileName="formData.MedicalCertificateFileName"
              :leaveApplicationId="formData.Id"
            ></download-mc-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center mb-4">
      <router-link
        class="btn btn-danger"
        :to="{ name: 'adminLeaveApplicationIndex' }"
        >Back</router-link
      >&nbsp;
      <button class="btn btn-primary" @click="print">Print</button>
    </div>
  </div>
</template>

<script>
import API from "../../../http-common.js";
import DownloadMcButton from "../../Shared/DownloadMedicalCertificateButton.vue";
export default {
  components: {
    DownloadMcButton,
  },
  data() {
    return {
      formData: null,
      // careerLibImgBase64:
      //   "data:image/jpeg;base64,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",
    };
  },
  computed: {
    token() {
      return localStorage.getItem("adminlmstoken");
    },
  },
  methods: {
    getLeaveApplicationDetail() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.admin
        .getLeaveApplicationDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.message == "Unauthorized access") {
            this.$swal("Multiple login detected. You have been logged out", {
              icon: "error",
            });
            this.$router.replace({ name: "adminLogin" });
            return;
          }

          if (response.data.success) {
            this.formData = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    print() {
      let orgLogo = this.formData.OrganisationLogo
        ? `<img style="width:100%;vertical-align:top" src="${this.formData.OrganisationLogo}"/>`
        : "";
      let html = `<html>
<head>
	<style>
    @media print {
      body {-webkit-print-color-adjust: exact;}
    }
		@page{size:auto; margin:5mm;}
		table, th, td {
			border: 1px solid black;
			border-collapse: collapse;
      font-family: Arial, Helvetica, sans-serif;
		}
    th, td{
      padding: 10px;
    }  
	</style>
  <title>LeaveApplication</title>
</head>

<body>
	<table style="width:100%">
        <tr>
          <td style="border-right-style:none;border-bottom-style:none;padding-bottom:0">${orgLogo}</td>
          <td style="border-left-style:none;border-bottom-style:none;border-right-style:none;width:1%"></td>
          <td style="text-align:right; vertical-align:top;border-left-style:none;border-bottom-style:none;"><img style="width:100%;" src="${API.constant.careerLibImgBase64}"/></td>
        </tr>
        <tr>
          <td colspan="3" style="border-top-style:none;padding-top:0">
            <label style="font-size: 1.3rem; font-weight: 600"
            >Leave Application</label><br />
            <p style="margin-top:1rem; margin-bottom:0.5rem;">
              <label style="width: 20px; margin: 0;font-weight: 600;">Employee&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>:
              <label style="width: 9rem;margin: 0 0 0.1rem 0.2rem;">${this.formData.EmployeeName}</label>
            </p>
            <p style="margin-top:0.5rem;">
              <label style="width: 5.1rem;margin: 0;font-weight: 600;">Created Date</label>:
              <label style="width: 9rem;margin: 0 0 0.1rem 0.2rem;">${this.formData.CreatedDateStr}</label>
            </p>
          </td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td><b>Leave Type</b></td>
          <td><b>Start Date</b></td>
          <td><b>End Date</b></td>
        </tr>
        <tr>
          <td width="33.33%">${this.formData.LeaveTypeDescription}</td>
          <td width="33.33%">${this.formData.StartDateDisplay}</td>
          <td width="33.33%">${this.formData.EndDateDisplay}</td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td colspan="3"><b>Number of Leave Days</b></td>
        </tr>
        <tr>
          <td colspan="3">${this.formData.NumberOfLeaveDays}</td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td colspan="3"><b>Remarks</b></td>
        </tr>
        <tr>
          <td colspan="3">${this.formData.Remarks}</td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td colspan="3"><b>Approver Name</b></td>
        </tr>
        <tr>
          <td colspan="3">${this.formData.ApproverName}</td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td colspan="3"><b>Approver Email</b></td>
        </tr>
        <tr>
          <td colspan="3">${this.formData.ApproverEmail}</td>
        </tr>
        <tr style="background-color: rgba(0,0,0,.05);">
          <td colspan="3"><b>Status</b></td>
        </tr>
        <tr>
          <td colspan="3">${this.formData.Status}</td>
        </tr>
    </table>
</body>
</html>`;
      let w = window.open("", "PRINT", "height=700,width=1300");
      w.document.write(html);
      //for i.e
      w.document.close();
      w.focus();
      //for the rest
      window.setTimeout(() => {
        w.print();
        w.close();
      }, 500);
      //w.print();
      //w.close();
    },
  },
  created() {
    this.getLeaveApplicationDetail();
  },
};
</script>

<style scoped>
.title {
  width: 5.1rem;
  margin: 0;
  font-weight: 600;
}
.content {
  width: 15rem;
  margin: 0 0 0.1rem 0.2rem;
}
.center {
  text-align: center;
}
</style>